export default {
  多元活动连接全球市场: "กิจกรรมหลากหลาย เชื่อมต่อตลาดโลก",
  共享全球顶级资源与学术支持:
    "เข้าถึงทรัพยากรที่ดีที่สุดจากทั่วโลกและการสนับสนุนความรู้ทางการเงิน สามารถช่วยให้คุณเริ่มต้นเส้นทางเทรดได้อย่างมั่นใจ",
  了解更多: "เรียนรู้เพิ่มเติม",
  敬请期待: "โปรดรอติดตาม",
  每个认真交易的人: "เทรดเดอร์ที่จริงจัง ต้องได้รับบริการที่จริงใจจากเรา",
  pageTitleH1: `รับโบนัสรายปีสูงสุด <span class="red">18%</span>`,
  pageTitleH2: "ยิ่งบริหารเงินทุนมาก ผลตอบแทนรายปียิ่งสูง",
  activityListMetaData: [
    {
      label: "กิจกรรมทางตลาด",
      list: [
         {
          id: "2-12",
          img: require("@/assets/image/activityList/banner2_12.png?v=2.0.0"),
          bannerTitle: `<img
          class="img-logo"
          src="${require("@/assets/image/logo/logo_row_white_th.svg")}"
          alt="logo"
        />
        <div class="barca2526-title en">เทรดครบ รับบัตรชม FC Barcelona สัมผัสประสบการณ์ชิดขอบสนามคัมป์นูใหม่</div>
        <img
          class="img-arrow"
          src="${require("@/assets/image/activityList/arrow.svg")}"
          alt=""
        />
        `,
          bannerBoxClass: "barca2526-title-box",
          bannerSubTitle: "",
          title: "เทรดครบ รับบัตรชม FC Barcelona สัมผัสประสบการณ์ชิดขอบสนามคัมป์นูใหม่",
          subtitle:
            "เทรดกับ EBC โบรกเกอร์ที่ดีที่สุด ลุ้นรับบัตรชมเกมเหย้าของ FC Barcelona พร้อมตั๋วเครื่องบินและที่พัก กระทบไหล่ซูเปอร์สตาร์ลูกหนังและร่วมเป็นส่วนหนึ่งของการเปิดตัวสนามคัมป์นูใหม่",
          url: "/activityList/barca2526",
          time: "",
        },
        {
          id: "2-4",
          img: require("@/assets/image/activityList/banner2_4New.png"),
          bannerTitle: "", //'เข้าร่วมโปรแกรมผู้จัดการกองทุน EBC',
          bannerSubTitle: 'รับโบนัสรายปีสูงสุด<span class="red">18%</span>',
          title: "โปรแกรมมาสเตอร์",
          subtitle:
            "โปรแกรมมาสเตอร์ ออกแบบมาให้นักเทรดมืออาชีพ ปล่อยสัญญาณเทรด พร้อมรับรางวัลเงินเดือนตามปริมาณเงินทุน โดยมีอัตราโบนัสสูงสุด 18% ต่อปี",
          url: "/pay",
          time: "",
        },
        {
          id: "2-3",
          img: require("@/assets/image/activityList/banner2_3.png"),
          bannerTitle: "สร้างสรรค์ผลงาน <br/>รับรายได้ทุกเดือน",
          bannerTitleClass: "creator-incentives-title",
          bannerSubTitle: "",
          bannerSubTitleClass: "creator-incentives-subtitle",
          title: "โปรแกรมครีเอทีฟ",
          subtitle:
            "เข้าร่วมโปรแกรมครีเอทีฟของ EBC เปลี่ยนพลังการสร้างสรรค์ของคุณให้กลายเป็นรายได้",
          url: "/activityList/creator-incentives",
          time: "",
        },
        {
          id: "2-9",
          img: require("@/assets/image/activityList/banner2_9_th.png"),
          title:
            "แข่งเทรด EBC Million Dollar Trading Challenge II ปิดฉากลงอย่างสมบูรณ์",
          subtitle: "Copy Trade แชมป์ฟรี",
          url: "/million-dollar-challenge-2",
          time: "",
        },
        // {
        //   id: "2-10",
        //   img: require("@/assets/image/activityList/messi_th.png"),
        //   title: "เทรดกับ EBC ลุ้นรับเสื้อบอลลิมิเต็ดพร้อมลายเซ็นเมสซี่",
        //   subtitle: "ระยะเวลากิจกรรม: 1 มี.ค. - 31 มี.ค. 2025",
        //   url: "/trade-for-messi",
        //   time: "",
        // },
        {
          id: "2-7",
          img: require("@/assets/image/activityList/banner2_7_th.png"),
          title: "EBC ร่วมมือกับ TradingView เชื่อมต่อตลาดการเงินทั่วโลก",
          subtitle:
            "รับสิทธิ์สมาชิก TradingView ฟรีภายในระยะเวลาจำกัด ควบคุมข้อมูลตลาดทั่วโลกแบบเรียลไทม์",
          url: "/TradingView",
          time: "",
        },
      ],
    },
    {
      label: "ข่าวสารและกิจกรรม EBC",
      list: [
        {
          id: "3-5",
          img: require("@/assets/image/activityList/banner3_5_th.png"),
          title: "EBC ร่วมงาน Money Expo Chile 2025",
          subtitle:
            "EBC โบรกเกอร์ชั้นนำระดับโลก  เตรียมสร้างปรากฏการณ์ครั้งสำคัญในงาน Money Expo Chile 2025 ซึ่งเป็นมหกรรมการเงินครั้งแรกของประเทศชิลี โดยเข้าร่วมในฐานะผู้สนับสนุนระดับไทเทเนียม พร้อมบูธขนาดใหญ่ที่สุดภายในงาน เพื่อแบ่งปันโอกาสการลงทุนและนำพาทุกท่านไปสู่เส้นทางการเป็นสุดยอดนักเทรด",
          url: "",
          time: "27–28 August 2025",
        },
        {
          id: "3-4",
          img: require("@/assets/image/activityList/banner3_4_th.png"),
          title: "EBC ร่วมงาน iFX EXPO ลาตินอเมริกา 2025",
          subtitle:
            "EBC เป็นผู้สนับสนุนระดับไดมอนด์ ที่บูธ 18 แชร์วิธีใช้บริการทางการเงินที่ล้ำสมัย ช่วยนักลงทุนคว้าโอกาสและลดความเสี่ยงในยุคการค้าโลกเปลี่ยนแปลง",
          url: "/LearningCenterInfo?id=LEARN-664-666",
          time: "9-10 April 2025",
        },
        {
          id: "3-3",
          img: require("@/assets/image/activityList/banner3_3_th.png"),
          title: "ไฮไลท์: EBC ในงาน Money Expo Mexico 2025",
          subtitle:
            "EBC เข้าร่วมงาน Money Expo Mexico 2025 ร่วมแลกเปลี่ยนแนวคิดกับผู้เชี่ยวชาญ เพื่อพัฒนาอุตสาหกรรมการเงิน และค้นหาโอกาสการลงทุนใหม่ๆ",
          url: "/LearningCenterInfo?id=LEARN-782-60B",
          time: "26-27 February 2025",
        },
        {
          id: "3-1",
          img: require("@/assets/image/activityList/banner3_1_th.png"),
          title: "วิธีใช้เศรษฐศาสตร์กับสภาพภูมิอากาศ เพื่อหาโอกาสในการเทรด",
          subtitle: `"นักเศรษฐศาสตร์จริงๆ แล้วทำอะไร" ค้นหาคำตอบเกี่ยวกับบทบาทของเศรษฐศาสตร์ในด้านการขับเคลื่อนนโยบายและการเติบโตทางเศรษฐกิจ`,
          url: "/partners/oxford",
          time: "November 14, 2024",
        },
        {
          id: "3-2",
          img: require("@/assets/image/activityList/banner3_2_th.png"),
          title: "EBC ร่วมมือกับมหาวิทยาลัย Oxford จัดซีรีส์สัมมนา",
          subtitle: `งานสัมมนาจะจัดขึ้นที่ Christ Church College มหาวิทยาลัย Oxford ในวันที่ 14 พฤศจิกายน เวลา 14:30 น. (ตามเวลา GMT) และจะมีการถ่ายทอดสดให้กับนักลงทุนจากทั่วโลกได้รับชม`,
          url: "/partners/oxford",
          time: "March 6, 2024",
        },
      ],
    },
  ],
};
